import { Box, Card, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ServiceTabs({
  title,
  description,
  image_blob,
  path,
  Icon,
}: {
  title: string;
  description: string;
  image_blob?: any;
  path?: string;
  Icon?: any;
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Box
      bgcolor={'#eee'}
      onClick={() => (path ? navigate(path) : alert('Coming Soon'))}
      height={'45vw'}
      width={'45vw'}
      className="snap-start flex-1 bg-white flex flex-col cursor-pointer justify-between py-2"
    >
      <Card
        elevation={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          flex: 1,
          justifyContent: 'space-between',
          borderRadius: 2,
          height: '45vw',
          width: '45vw',
        }}
      >
        <img src={image_blob} alt={title} className="w-[45vw] h-[45vw] object-contain " />
        <div className="object-contain self-end">
          {Icon && <Icon size={60} color={theme.palette.grey[600]} />}
        </div>
      </Card>
    </Box>
  );
}
